const HOSTNAME = window.location.hostname
// const getEnvironment = () => {
//   if (HOSTNAME.startsWith('test') || HOSTNAME === '192.168.40.45') {
//     return 'test'
//   }
//   if (
//     HOSTNAME.startsWith('dev') ||
//     HOSTNAME === '192.168.40.44' ||
//     HOSTNAME === 'localhost'
//   ) {
//     return 'dev'
//   }
//   return 'prod'
// }
// const environment = getEnvironment()
const API_BASE_URLS = {
  // dev: 'https://dev.shinhanx.kz',
  // test: 'https://test.shinhanx.kz',
  prod: 'https://xcars.kz'
}
// export const isDevelop = environment === 'dev'

export const AUTH_API_URL = `${API_BASE_URLS['prod']}/api-auth`
export const MISC_API_URL = `${API_BASE_URLS['prod']}/api-misc`
export const CAR_API_URL = `${API_BASE_URLS['prod']}/api-car`
export const CP_API_URL = `${API_BASE_URLS['prod']}/api-cp`
export const SALE_API_URL = `${API_BASE_URLS['prod']}/api-sale`
export const FB_API_URL = `${API_BASE_URLS['prod']}/api-fb`
